import PropTypes from 'prop-types';
import React from 'react';
import slugify from '@surfline/web-common/dist/slugify';
import PremiumAnalysisLink from '@surfline/quiver-react/dist/PremiumAnalysisLink';
import { postedDate, nextUpdateDate } from '@surfline/web-common/dist/utils/formatReportDate';
import ForecasterProfile from '@surfline/quiver-react/dist/ForecasterProfile';
import Bets from '../Bets';
import ForecastHighlights from '../ForecastHighlights';
import config from '../../config';
import en from '../../intl/translations/en';
import premiumAnalysisClickEventPropType from '../../propTypes/premiumAnalysisClickEvent';

const RegionForecastUpdate = ({
  forecastSummary: { forecaster, hasBets, hasHighlights, bets, highlights, nextForecastTimestamp },
  subregionId,
  subregionName,
  timestamp,
  utcOffset,
  abbrTimezone,
  doTrackEvent,
  isPremium,
  condition,
  clickEventProps,
  doClickedSubscribeCTA,
}) => (
  <div className="sl-region-forecast-update">
    {forecaster ? (
      <ForecasterProfile
        forecasterName={forecaster.name}
        forecasterTitle={forecaster.title}
        url={forecaster.iconUrl}
        lastUpdate={postedDate(timestamp, utcOffset, abbrTimezone)}
        nextUpdate={nextUpdateDate(nextForecastTimestamp, utcOffset, abbrTimezone)}
        condition={condition || 'POOR'}
        expired={!condition}
        baseUrl={config.surflineHost}
      />
    ) : null}
    {isPremium ? (
      <div className="sl-region-forecast-update__body">
        {hasBets ? <Bets bets={bets} /> : null}
        {hasBets && hasHighlights ? <div className="sl-region-forecast-update__divider" /> : null}
        {hasHighlights ? <ForecastHighlights highlights={highlights} /> : null}
        <PremiumAnalysisLink
          link={en.RegionalForecast.pageLevelLinkText.premiumAnalysis.path(
            slugify(subregionName),
            subregionId
          )}
          doTrackEvent={doTrackEvent}
          clickEventProps={clickEventProps}
        />
      </div>
    ) : (
      <div className="sl-region-forecast-update__cta">
        <div className="sl-region-forecast-update__cta__text">
          {en.premiumCTA.RegionForecastUpdateCTA.defaultText}
        </div>
        <a
          className="sl-region-forecast-update__cta__go-premium"
          href={config.funnelUrl}
          onClick={() =>
            doClickedSubscribeCTA({
              ctaLocation: 'go premium - forecast analysis',
              subregionId,
              pageName: 'Regional Forecast',
              category: 'regional forecast',
            })
          }
        >
          {en.premiumCTA.RegionForecastUpdateCTA.linkText}
        </a>
      </div>
    )}
  </div>
);

RegionForecastUpdate.propTypes = {
  forecastSummary: PropTypes.shape({
    forecaster: PropTypes.shape({
      name: PropTypes.string,
      title: PropTypes.string,
      email: PropTypes.string,
      iconUrl: PropTypes.string,
    }),
    hasBets: PropTypes.bool.isRequired,
    hasHighlights: PropTypes.bool.isRequired,
    highlights: PropTypes.arrayOf(PropTypes.string),
    bets: PropTypes.shape({
      best: PropTypes.string,
      worst: PropTypes.string,
    }).isRequired,
    nextForecastTimestamp: PropTypes.number,
  }).isRequired,
  subregionId: PropTypes.string.isRequired,
  subregionName: PropTypes.string.isRequired,
  timestamp: PropTypes.number.isRequired,
  condition: PropTypes.string.isRequired,
  isPremium: PropTypes.bool.isRequired,
  utcOffset: PropTypes.number.isRequired,
  abbrTimezone: PropTypes.string.isRequired,
  doTrackEvent: PropTypes.func.isRequired,
  clickEventProps: premiumAnalysisClickEventPropType.isRequired,
  doClickedSubscribeCTA: PropTypes.func.isRequired,
};

export default RegionForecastUpdate;
